export const EVENTPLANNER_URL = '/eventplanner'
export const DASHBOARD_URL = `${EVENTPLANNER_URL}/dashboard`
export const INBOX_URL = `${EVENTPLANNER_URL}/inbox`
export const HELP_URL = `${EVENTPLANNER_URL}/help`
